import { render, staticRenderFns } from "./FloatingIframe.vue?vue&type=template&id=e97c656c&scoped=true"
import script from "./FloatingIframe.vue?vue&type=script&lang=js"
export * from "./FloatingIframe.vue?vue&type=script&lang=js"
import style0 from "./FloatingIframe.vue?vue&type=style&index=0&id=e97c656c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97c656c",
  null
  
)

export default component.exports